import {
    Routes,
    Route, Navigate
} from "react-router-dom";
import {
    Login,
    Main,
    MyRequests,
    MyShift,
    Request,
    Requests,
    RequestSingle,
    SignUp,
    MyRequestSingle,
    MyShiftInfo, MyAccount, EditRequest, PanelMain
} from "./pages";
import ScrollToTop from "./components/scroll-to-top/scroll-to-top";
import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {fetchData} from "./helpers/general-function";
import {setSplashData} from "./redux/splash/splash.action";

function App() {

    const dispatch = useDispatch();
    const isLogged = useSelector(state => state.user.is_login);

    useEffect(() => {
        (async () => {
            const data = await fetchData('home', 'get', {
                // city_id: 1,
                // province_id: 1,
                offset: 0
            }, isLogged);

            if(data) {
                dispatch(setSplashData(data));
            }
        })()
    }, [isLogged])

    return (
        <ScrollToTop>
            <Routes>
                <Route path='/' element={<Main/>}/>
                {
                    isLogged ?
                        <>
                            <Route path='/request-single/:shift_id' element={<RequestSingle/>}/>
                            <Route path='/requests' element={<Requests/>}/>

                            <Route path='/request' element={<Request/>}/>

                            <Route path='/panel' element={<PanelMain/>}/>
                            <Route path='/panel/my-requests' element={<MyRequests/>}/>
                            <Route path='/panel/my-request-single/:shift_time_id' element={<MyRequestSingle/>}/>
                            <Route path='/panel/edit-request/:request_id' element={<EditRequest/>}/>
                            <Route path='/panel/my-shifts' element={<MyShift/>}/>
                            <Route path='/panel/my-shift-info/:shift_request_id' element={<MyShiftInfo/>}/>
                            <Route path='/panel/my-account' element={<MyAccount/>}/>

                            <Route path='/sign-up' element={<Navigate to="/" />}/>
                            <Route path='/login' element={<Navigate to="/" />}/>
                        </>
                        :
                        <>
                            <Route path='/sign-up' element={<SignUp/>}/>
                            <Route path='/login' element={<Login/>}/>

                            <Route path='/request-single/:shift_id' element={<Navigate to="/login" />}/>
                            <Route path='/requests' element={<Navigate to="/login" />}/>
                            <Route path='/request' element={<Navigate to="/login" />}/>
                            <Route path='/panel' element={<Navigate to="/login" />}/>
                            <Route path='/panel/my-requests' element={<Navigate to="/login" />}/>
                            <Route path='/panel/my-request-single/:shift_time_id' element={<Navigate to="/login" />}/>
                            <Route path='/panel/edit-request/:request_id' element={<Navigate to="/login" />}/>
                            <Route path='/panel/my-shifts' element={<Navigate to="/login" />}/>
                            <Route path='/panel/my-shift-info/:shift_request_id' element={<Navigate to="/login" />}/>
                            <Route path='/panel/my-account' element={<Navigate to="/login" />}/>
                        </>
                }
            </Routes>
        </ScrollToTop>
    );
}

export default App;
